import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import YearPicker from "dashboards/lite/YearPicker";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import ChartHelpModal from "dashboards/lite/ChartHelpModal";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function OverviewDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "total", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "total", "spend"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;


  let mainIcon = require("images/lite/icons/overview.svg");
  mainIcon = <div className="overview-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>
  let disabledIcon = require("images/lite/icons/coming-soon.png");
  disabledIcon = <div className="coming-soon-icon"><img src={`/datapulse${disabledIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(jsDig(["client_account", "dashboard_objective"], props) ? jsDig(["client_account", "dashboard_objective"], props) : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let merOrCpa = dashboardObjective == "sales" ? "mer" : "cpa";

  const dashboardType = "overview"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  return (
    <>
      <div className="lite-dashboard overview-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Overview Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker/>
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"overview"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Overview" />
            </div>
          </div>
        </div>

        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "spend", "data"], props.chart_data)}
                chartName="Ad Spend L60D"
                metric="spend"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={revenueOrConversions == "revenue" ? `${capitalize(revenueOrConversions)} Weekly` : capitalize(revenueOrConversions)}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", merOrCpa, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", merOrCpa, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", merOrCpa, "data"], props.chart_data)}
                chartName={`${merOrCpa.toUpperCase()} L60D`}
                metric={merOrCpa}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "sessions", "data"], props.chart_data)}
                chartName="Website Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "conversion_rate", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "conversion_rate", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "conversion_rate", "data"], props.chart_data)}
                chartName="CVR L60D"
                metric="conversion_rate"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          {dashboardObjective == "sales" && (
            <div className="lite-dashboard-section">
              <div className="lite-metric-chart">
                <LiteLineChart 
                  datasetNames={jsDig(["overall", "total", "aov", "dataset_names"], props.chart_data)}
                  labels={jsDig(["overall", "total", "aov", "labels"], props.chart_data)}
                  data={jsDig(["overall", "total", "aov", "data"], props.chart_data)}
                  chartName="AOV L60D"
                  metric="aov"
                  colorBlindAssist={props.color_blind_assist}
                />
              </div>
              <div className="lite-metric-chart">
                <LiteLineChart 
                  datasetNames={jsDig(["overall", "total", "customer_acquisition_cost", "dataset_names"], props.chart_data)}
                  labels={jsDig(["overall", "total", "customer_acquisition_cost", "labels"], props.chart_data)}
                  data={jsDig(["overall", "total", "customer_acquisition_cost", "data"], props.chart_data)}
                  chartName="New Customer Acquisition Cost L60D"
                  metric="customer_acquisition_cost"
                  colorBlindAssist={props.color_blind_assist}
                />
              </div>
            </div>
          )}
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, merOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "total"], props.table_data)}
                tableName="Total Performance"
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "marketing_spend_funnel", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "marketing_spend_funnel", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "marketing_spend_funnel", "spend", "data"], props.chart_data)}
                chartName="Marketing Spend Funnel Allocation"
                metric="stacked"
                tooltipData={jsDig(["overall", "marketing_spend_funnel", "spend", "tooltip_data"], props.chart_data)}
                tooltipMetric="spend"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", "spend", revenueOrConversions, merOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60"], props.table_data)}
                tableName="Total Performance - Daily L60D"
                dimensions={jsDig(["overall", "l60", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "spend"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
